import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import SiteLayout from "@/components/SiteLayout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Causes from "@/pages/Causes";
import Grant from "@/pages/Grant";
import Donate from "@/pages/Donate";
import Volunteer from "@/pages/Volunteer";
import Blog from "@/pages/Blog";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors theme="dark" />
          <Routes>
            <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
            <Route path="/causes" element={<SiteLayout><Causes /></SiteLayout>} />
            <Route path="/grants" element={<SiteLayout><Grant /></SiteLayout>} />
            <Route path="/donate" element={<SiteLayout><Donate /></SiteLayout>} />
            <Route path="/volunteer" element={<SiteLayout><Volunteer /></SiteLayout>} />
            <Route path="/blog" element={<SiteLayout><Blog /></SiteLayout>} />
            <Route path="/contact" element={<SiteLayout><Contact /></SiteLayout>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
